// extracted by mini-css-extract-plugin
module.exports = {"cardWrapperContainer":"searchResultsContainer_cardWrapperContainer__F_B5a","cardWrapper":"searchResultsContainer_cardWrapper__cDfTE"};